<template>
  <!-- top courses -->
   <section class="master-skill-three">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-xl-5 col-lg-6 col-md-12 mb-md-0" style="margin-bottom: 80px;" data-aos="fade-up">
          <div class="master-three-images">
            <div class="master-img">
              <img
                class="img-fluid master-bg1"
                src="@/assets/img/shapes/shape-10.svg"
                alt="img"
              />
              <img
                class="img-fluid master-bg2"
                src="@/assets/img/shapes/shape-7.svg"
                alt="img"
              />
              <img
                class="img-fluid master-skill-image1"
                src="@/assets/img/gallery/gallery-02.webp"
                alt="img"
                style="height: 409px; width: 475px;"
              />
              <div class="text-end">
                <img
                  class="img-fluid master-skill-image2"
                  src="@/assets/img/gallery/gallery-04.webp"
                  alt="img"
                  style="    
                  height: 253px;
                  width: 326px;
                  top: 100px;"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-7 col-lg-6 col-md-12" data-aos="fade-up">
          <div class="master-skill-content">
            <div class="home-five-head" data-aos="fade-up">
              <h2>Kuasai Keahlian untuk Karir Anda</h2>
            </div>
            <div class="home-five-content" data-aos="fade-up">
              <p>
                Dapatkan sertifikasi, kuasai keterampilan teknologi modern, dan tingkatkan karir Anda baik sebagai pemula maupun profesional berpengalaman. 95% peserta melaporkan konten praktis kami sangat membantu pekerjaan mereka.
              </p>
            </div>
            <div class="skils-group">
              <div class="row row-gap-4">
                <div class="col-lg-6 col-xs-12 col-sm-6" data-aos="fade-down">
                  <div class="skils-icon-item">
                    <div class="skils-icon">
                      <img
                        class="img-fluid"
                        src="@/assets/img/icon/career-01.svg"
                        alt="certified"
                      />
                    </div>
                    <div class="skils-content">
                      <h5 class="mb-2">Kursus Bersertifikat</h5>
                      <p class="mb-0">Dapatkan sertifikat internal untuk setiap modul yang diselesaikan.</p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-xs-12 col-sm-6" data-aos="fade-up">
                  <div class="skils-icon-item">
                    <div class="skils-icon">
                      <img
                        class="img-fluid"
                        src="@/assets/img/icon/career-02.svg"
                        alt="Build skills"
                      />
                    </div>
                    <div class="skils-content">
                      <h5 class="mb-2">Pengembangan Skill</h5>
                      <p class="mb-0">Bangun keahlian Anda melalui materi yang terstruktur.</p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-xs-12 col-sm-6" data-aos="fade-up">
                  <div class="skils-icon-item">
                    <div class="skils-icon">
                      <img
                        class="img-fluid"
                        src="@/assets/img/icon/career-03.svg"
                        alt="Stay Motivated"
                      />
                    </div>
                    <div class="skils-content">
                      <h5 class="mb-2">Tetap Terinspirasi</h5>
                      <p class="mb-0">Belajar dengan metode yang interaktif dan menarik.</p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-xs-12 col-sm-6" data-aos="fade-up">
                  <div class="skils-icon-item">
                    <div class="skils-icon">
                      <img
                        class="img-fluid"
                        src="@/assets/img/icon/career-04.svg"
                        alt="latest cloud"
                      />
                    </div>
                    <div class="skils-content">
                      <h5 class="mb-2">Terus Berkembang</h5>
                      <p class="mb-0">Ikuti perkembangan teknologi terbaru di industri.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /top courses -->

  <!-- trust -->
  <section class="trust-sec">
    <div class="container">
      <div class="video-showcase">
        <img
          src="@/assets/img/gallery/gallery-01.webp"
          class="img-fluid w-100 rounded-2"
          alt="banner"
        />
        <div class="video-play">
          <a href="https://www.youtube.com/embed/nAx3ITaWWEU" data-fancybox=""
            ><i class="isax isax-play5"></i
          ></a>
        </div>
      </div>
      <div class="trust-content">
        <img src="@/assets/img/bg/bg-19.png" alt="img" class="w-100 trust-bg" />
        <div class="row justify-content-between">
          <div class="col-md-4">
            <h4>Dipercaya oleh ratusan karyawan Sapta untuk pengembangan diri sejak 2020</h4>
            <div class="d-flex align-items-center flex-wrap mt-5 gap-2">
              <router-link to="/" class="btn btn-secondary"
                >Mulai Belajar</router-link
              >
              <router-link to="/pages/become-an-instructor" class="btn btn-dark"
                >Daftar Jadi Mentor</router-link
              >
            </div>
          </div>
          <div class="col-md-7">
            <div class="row">
              <div class="col-md-6">
                <h4 class="text-white mb-2">9.8/10</h4>
                <h5 class="text-white mb-2">Skor Kepuasan Materi</h5>
                <p class="text-white mb-5">
                  Materi yang relevan dan mudah dipahami oleh tim teknis.
                </p>
              </div>
              <div class="col-md-6">
                <h4 class="text-white mb-2">500+</h4>
                <h5 class="text-white mb-2">Karyawan Aktif Belajar</h5>
                <p class="text-white mb-5">
                  Bergabung dengan rekan tim lainnya dalam meningkatkan kompetensi.
                </p>
              </div>
            </div>
            <div class="d-flex align-items-center bg-white user-goal p-2">
              <div class="avatar avatar-lg flex-shrink-0">
                <img class="rounded-pill" src="@/assets/img/students/profile-avatar.png" alt="img" />
              </div>
              <p class="text-gray-9 mb-0">
                “Semua materi sangat membantu saya dalam menyelesaikan tugas di lapangan dengan lebih efisien.”
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /trust -->
</template>

<script>
import HomeCourses from "@/assets/json/home-courses.json";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

export default {
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data() {
    return {
      HomeCourses: HomeCourses,
    };
  },
  setup() {
    return {
      // carousel settings
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },

      breakpoints: {
        // 700px and up
        700: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 6,
          snapAlign: "start",
        },
      },
    };
  },
};
</script>
